module.exports = __webpack_public_path__ + "media/images/redesign-images/shared/best-sellers/best-sellers-01-816c04b5feb59cf66aacbdd2ce66181a.jpg";